import { useAuthUser } from "hooks/authentication";
import { useNavigate } from "react-router-dom";
import { CookieService } from "service/cookies";

const AuthenNavigate = () => {
  const { user, initializing } = useAuthUser();
  const navigate = useNavigate();

  if (initializing) {
    return;
  }

  if (!CookieService.getToken() && !user?.email) {
    navigate("/");
  }
};

export { AuthenNavigate as authenNavigate };
